<template>
    <v-app-bar
        v-if="!route.path.includes('read-book')"
        scroll-behavior="hide"
        density="comfortable"
        color="header"
        class="horizontal"
    >
        <div class="wrap">
            <div class="d-flex justify-space-between align-center px-3">
                <div>
                    <template v-if="school?.type.abbrv == 'WS'">
                        <div class="wslogo">
                            <RouterLink to="/pupil/home"><img :src="`/common/img/ws.png`" /></RouterLink>
                            <span>with Giglets Education</span>
                        </div>
                        <div class="wslogo-gap">&nbsp;</div>
                    </template>
                    <template v-else>
                        <RouterLink class="home" to="/pupil/home"
                            ><i class="icon icon-giglets"></i><span class="logo-text">giglets</span></RouterLink
                        >
                    </template>

                    <RouterLink class="books" to="/pupil/change-book">
                        <i class="fa fa-book"></i><span class="title"> {{ lang.get('Library') }}</span>
                    </RouterLink>

                    <RouterLink v-if="book" class="books" to="/pupil/read-book">
                        <i class="fa fa-book-open"></i><span class="title"> {{ lang.get('Book') }}</span>
                    </RouterLink>
                    <template v-if="school?.ask_teacher && school?.type.abbrv == 'PREM'">
                        <RouterLink class="messages" to="/pupil/messages">
                            <i class="fa fa-message"></i>
                            <span class="title"> {{ lang.get('Messages') }}</span>
                            <span v-show="unreadMessageCount > 0" class="fa-stack fa-3x msg-icn-cntnr-spn-ppl">
                                <i id="msg-notification" class="fa fa-comments fa-stack-2x msg-icn-ppl"></i>
                                <span class="fa fa-stack-1x">
                                    <span class="msg-icn-txt-spn-ppl">
                                        <p class="msg-icn-txt-ppl">
                                            {{ unreadMessageCount > 9 ? '9+' : unreadMessageCount }}
                                        </p>
                                    </span>
                                </span>
                            </span>
                        </RouterLink>
                    </template>
                    <template v-else-if="school && school.type.abbrv != 'PREM'">
                        <RouterLink id="ask_teacher_upgrade" class="messages" to="/pupil/tlc-upgrade">
                            <i class="fa fa-message"></i>Message
                            <i class="fa fa-lock featurelock" aria-hidden="true"></i>
                        </RouterLink>
                    </template>
                </div>

                <div v-if="pupil" class="ddhold">
                    <RouterLink to="/pupil/profile" class="user pull-right probtn btn-small">
                        <img
                            class="avatar"
                            :src="`/common/img/avatars/${pupil.avatar ? pupil.avatar : 'default.jpg'}`"
                            alt=""
                        />
                        <span id="header_pupil_span" class="title dd-privacy-mask">
                            {{ pupilName }}
                        </span>
                    </RouterLink>
                </div>
            </div>
        </div>
    </v-app-bar>
    <v-app-bar v-else color="header" density="comfortable" class="horizontal reader">
        <div class="wrap">
            <div class="grid no-gutters">
                <div class="unit">
                    <!-- On purpose we do not use RouterLink here, but a.
                         This is to reload the app after reading a book because reader.js/selection.js has created a lot of hooks that we want to remove.
                         Should find a better way of doing this...
                    -->
                    <template v-if="school?.type.abbrv == 'WS'">
                        <div class="wslogo">
                            <a @click="goHome"><img :src="`/common/img/ws.png`" /></a
                            ><span>with Giglets Education</span>
                        </div>
                        <div class="wslogo-gap">&nbsp;</div>
                    </template>
                    <template v-else>
                        <a class="home" @click="goHome"
                            ><i class="icon icon-giglets"></i><span class="logo-text">giglets</span></a
                        >
                    </template>

                    <a id="contents" class="contents" href="">
                        <i class="fa fa-list-ol"></i>
                        <span class="title">{{ lang.get('Contents') }}</span>
                    </a>
                    <a id="textstyle" class="style" href="">
                        <span class="font-size-icon">
                            <i class="small fa fa-font"></i>
                            <i class="large fa fa-font"></i>
                        </span>
                        <span class="title">{{ lang.get('Size') }}</span>
                    </a>
                    <ul
                        v-show="displayFontDropdown"
                        ref="fontsdd"
                        v-closable="{
                            handler: () => (displayFontDropdown = false),
                            exclude: ['fontsize'],
                        }"
                        class="submenu colour-dropdown"
                    >
                        <li>
                            <a href="#" :class="`hein-sel${!pupil?.font_name ? ' selected' : ''}`" @click="setFont()">{{
                                lang.get('Use font one')
                            }}</a>
                        </li>
                        <li>
                            <a
                                href="#"
                                :class="`od-sel${pupil?.font_name ? ' selected' : ''}`"
                                @click="setFont('od')"
                                >{{ lang.get('Use font two') }}</a
                            >
                        </li>
                    </ul>
                    <a ref="fontsize" class="style" @click="showFontDropdown">
                        <i class="fa fa-font"></i>
                        <span class="title">{{ lang.get('Font') }}</span>
                    </a>
                    <ul id="colours" class="submenu colour-dropdown" style="display: none">
                        <li>
                            <a href="#ffffff">{{ lang.get('White') }}</a>
                        </li>
                        <li>
                            <a href="#f2f2f2">{{ lang.get('Ivory') }}</a>
                        </li>
                        <li>
                            <a href="#d8d8d8">{{ lang.get('Grey') }}</a>
                        </li>
                        <li>
                            <a href="#ceecf5">{{ lang.get('Blue') }}</a>
                        </li>
                        <li>
                            <a href="#f6cece">{{ lang.get('Pink') }}</a>
                        </li>
                        <li>
                            <a href="#fee2a9">{{ lang.get('Yellow') }}</a>
                        </li>
                        <li>
                            <a href="#f5ecce">{{ lang.get('Sepia') }}</a>
                        </li>
                        <li>
                            <a href="#d499ff">{{ lang.get('Purple') }}</a>
                        </li>
                        <li>
                            <a href="#000000#ffffff">{{ lang.get('Black / White') }}</a>
                        </li>
                        <li>
                            <a href="#000000#ffff00">{{ lang.get('Black / Yellow') }}</a>
                        </li>
                    </ul>
                    <a id="bgselect" class="style" href="">
                        <i class="fa fa-paint-brush"></i><span class="title">{{ lang.get('Colour') }}</span>
                    </a>

                    <a
                        v-if="school?.ask_teacher && school.type.abbrv == 'PREM'"
                        id="ask_teacher"
                        class="help pull-right"
                        @click="askTeacher?.show()"
                        ><i class="fa fa-message"></i>
                    </a>
                    <RouterLink
                        v-else-if="school && school?.type.abbrv != 'PREM'"
                        id="ask_teacher_upgrade"
                        class="help pull-right"
                        to="/pupil/tlc-upgrade"
                    >
                        <i class="fa fa-message"></i>Ask the Teacher<i
                            class="fa fa-lock featurelock"
                            aria-hidden="true"
                        ></i>
                    </RouterLink>

                    <ul id="highlight_colours" style="display: none">
                        <li class="green">
                            <a href="#green"><i class="fa fa-highlighter"></i>{{ lang.get('Green') }}</a>
                        </li>
                        <li class="pink">
                            <a href="#pink"><i class="fa fa-highlighter"></i>{{ lang.get('Pink') }}</a>
                        </li>
                        <li class="yellow">
                            <a href="#yellow"><i class="fa fa-highlighter"></i>{{ lang.get('Yellow') }}</a>
                        </li>
                        <li class="cyan">
                            <a href="#cyan"><i class="fa fa-highlighter"></i>{{ lang.get('Cyan') }}</a>
                        </li>
                        <li class="magenta">
                            <a href="#magenta"><i class="fa fa-highlighter"></i>{{ lang.get('Magenta') }}</a>
                        </li>
                        <li class="none">
                            <a href="#"><i class="fa fa-highlighter"></i>{{ lang.get('Clear highlight') }}</a>
                        </li>
                    </ul>

                    <template v-if="school?.type.abbrv == 'PREM'">
                        <a id="highlight_colour" class="pull-right" href="#" data-dd-action-name="Highlight Color">
                            <i class="fa fa-highlighter"></i>
                            <span class="title"></span>
                        </a>
                        <a id="search" class="pull-right" href="#" data-dd-action-name="Search"
                            ><i class="fa fa-search"></i><span class="title"></span
                        ></a>
                        <div id="search_box" style="display: none">
                            <input
                                id="search_text"
                                type="text"
                                :placeholder="lang.get('Search text') + '...'"
                                name="search_text"
                            />
                            <input
                                id="search_submit"
                                class="btn btn-small"
                                style="border: 0"
                                type="submit"
                                :value="lang.get('Search')"
                            />
                        </div>
                    </template>
                    <template v-else-if="school">
                        <RouterLink id="highlight_colour_upgrade" class="pull-right" to="/pupil/tlc-upgrade">
                            <i class="fa fa-highlighter"></i><i class="fa fa-lock featurelock" aria-hidden="true"></i
                            ><span class="title"></span>
                        </RouterLink>
                        <RouterLink id="search_upgrade" class="pull-right" to="/pupil/tlc-upgrade">
                            <i class="icon2 icon2-search"></i><i class="fa fa-lock featurelock" aria-hidden="true"></i
                            ><span class="title"></span>
                        </RouterLink>
                    </template>

                    <a id="audioreveal" class="pull-right" href="#" data-dd-action-name="Audio"
                        ><i class="fa fa-volume-up">&nbsp;</i></a
                    >
                    <div id="audioplayer_container" style="display: none">
                        <audio id="audioplayer" controls>
                            <source id="audiosource" src="" type="audio/mpeg" />
                        </audio>
                    </div>
                </div>
            </div>
        </div>
    </v-app-bar>
    <PupilAskTeacher ref="askTeacher" />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import PupilAskTeacher from '~/components/pupil/AskTeacher.vue';

const store = usePupilStore();
store.fetchPupil();
store.fetchBook();
store.fetchSchool();
store.fetchMessages();
const { pupil, book, school, messages, bookSessionId } = storeToRefs(store);

const lang = useLang();
const displayDropdown = ref(false);
const displayFontDropdown = ref(false);
const title = ref<string>('Giglets');
const askTeacher = ref<InstanceType<typeof PupilAskTeacher> | null>(null);
const fontsize = ref<HTMLElement | null>(null);
const fontsdd = ref<HTMLElement | null>(null);

const bodyClasses = useBodyClasses();
const route = useRoute();

const unreadMessageCount = computed<number>(() => messages.value.filter((m) => !m.msg_read && !m.to_teacher).length);

watchEffect(() => {
    const font = pupil.value?.font_name || 'hein';

    title.value = school.value && school.value.type.abbrv.toLowerCase() === 'WS' ? 'WorldStories' : 'Giglets';

    const classes = ['pupil', font, lang.language.value];
    bodyClasses.addClasses(classes);
});

const pupilName = computed(() => {
    if (!pupil.value || !pupil.value.name) {
        return '';
    }
    return pupil.value.name.length < 20 ? pupil.value.name : pupil.value.name.substring(0, 20) + '...';
});

useHead({ title });

function setFont(font = '') {
    store.updatePupil({ font_name: font });
    displayDropdown.value = false;
    displayFontDropdown.value = false;
}

function showFontDropdown() {
    if (!fontsize.value || !fontsdd.value) {
        return;
    }
    fontsdd.value.style.left = fontsize.value.offsetLeft - 10 + 'px';
    displayFontDropdown.value = !displayFontDropdown.value;
}

async function goHome() {
    try {
        await $fetch('/api/pupil/current/track', {
            method: 'POST',
            body: {
                type: 'session_end',
                bookSessionId: bookSessionId.value,
            },
        });
    } catch (error) {
        console.error('Failed to send tracking', error);
    }
    window.location.href = import.meta.env.BASE_URL + 'pupil/home';
}
</script>
<style lang="scss" scoped>
:deep(.v-toolbar__content) {
    overflow: visible;
}

.font-size-icon {
    position: relative !important;
    max-width: 24px !important;
    overflow: visible !important;

    .small {
        left: 15px !important;
        font-size: 18px !important;
    }

    .large {
        font-size: 24px !important;
    }
}

.toggle:hover i {
    color: #fff;
    background: transparent;
}

.horizontal .wrap {
    padding: 0 20px;
}

.horizontal .help,
.horizontal .books,
.horizontal .messages,
.horizontal .help {
    text-decoration: none;
    margin: 0px 25px 0 0;
    padding: 0;
    color: #fff;
    text-align: left;
    font-size: 16px;
    font-family: HeinemannSpecial-Bold;
}

body.od .horizontal .help,
body.od .horizontal .books,
body.od .horizontal .messages,
body.od .horizontal .help {
    font-family: open-dyslexic-bold;
}

.horizontal .help {
    margin-top: 0px;
    position: relative;
    top: 9px;
    margin-left: 10px;
}

.horizontal .contents,
.horizontal .ws,
.horizontal .style {
    text-decoration: none;
    margin: 0px 25px 0 0;
    padding: 0;
    color: #fff;
    text-align: left;
    font-size: 16px;
    font-family: HeinemannSpecial-Bold;
}

body.od .horizontal .style {
    font-family: open-dyslexic-bold;
}

.horizontal i {
    color: #008fd5;
    opacity: 1;
    font-size: 32px;
    display: inline-block;
    position: relative;
    top: 8px;
    margin: 0 8px 0 0;
}

.horizontal i.fa {
    top: 4px;
    font-size: 24px;
}

.horizontal i.fa.fa-volume-up {
    top: 10px;
    font-size: 28px;
}

.horizontal i.fa.fa-highlighter {
    top: 10px;
    font-size: 28px;
}

.horizontal span.title {
    color: #fff;
}

.horizontal a:hover i {
    color: #fff;
}

.horizontal .contents i,
.horizontal .help i {
    left: 3px;
}

.horizontal .home {
    text-decoration: none;
    margin-right: 30px;
    padding: 0;
    color: #47585e;
    text-align: left;
    font-size: 25px;
    font-family: HeinemannSpecial-Bold;
}

body.od .horizontal .home {
    font-family: open-dyslexic-bold;
}

.horizontal .home i {
    font-size: 32px;
    margin-right: 8px;
    position: relative;
    top: 8px;
}

.horizontal .home span.logo-text {
    font-size: 26px;
    color: #fff;
    font-family: HeinemannSpecial-Bold;
}

.horizontal .probtn {
    color: #fff;
    background: #263033;
    margin: 9px 0 0 0;
}

.horizontal .user img {
    width: 21px;
    margin: 0 10px 0 0;
    display: block;
    float: left;
}

.horizontal .user .title {
    margin-top: 7px;
    display: inline-block;
}

.horizontal #header_pupil_span.title {
    max-width: 200px;
}

.horizontal div.search {
    float: right;
    margin: 9px 0 0 0;
}

.horizontal div.search input[type='text'] {
    color: #c4cacc;
    outline: none;
    width: 210px;
    border: 0;
    background: #13181a;
    padding: 6px 10px 2px 10px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
}

.horizontal i.featurelock {
    color: #d00000;
    font-size: 18px !important;
    top: 1px !important;
    margin-left: 0px;
    display: inline-block;
}

.horizontal a#highlight_colour_upgrade i.featurelock {
    top: 9px !important;
}
</style>
